var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2140_21483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19H13V32H19V19H32V13H19V0H13V13H0V19Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4325 20.8696L32 27.4371V20.8696H25.4325Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8698 20.8696L32.0002 32V28.8525L24.0173 20.8696H20.8698Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0355 32L20.8698 23.8335V32H29.0355Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8698 20.8696L32.0002 32V28.8525L24.0173 20.8696H20.8698Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8698 20.8696L32.0002 32V28.8525L24.0173 20.8696H20.8698Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01888 20.8696L0 25.8884V20.8696H5.01888Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1298 22.285V31.9999H1.41571L11.1298 22.285Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98275 20.8698L0 28.8526V32L11.1302 20.8698H7.98275Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5675 11.1305L0 4.56299V11.1305H6.5675Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1304 11.1304L0 0V3.1475L7.98294 11.1304H11.1304Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96521 0L11.1309 8.16644V0H2.96521Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1304 11.1304L0 0V3.1475L7.98294 11.1304H11.1304Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1304 11.1304L0 0V3.1475L7.98294 11.1304H11.1304Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9816 11.1304L32.0005 6.11156V11.1304H26.9816Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8698 9.71509V0.000213623H30.5839L20.8698 9.71509Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0173 11.1302L32 3.14744V0L20.8698 11.1302H24.0173Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2140_21483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/English.c9a85bf846aec1bdbdbb19aa1a8d1029.svg";
export { ForwardRef as ReactComponent };